export default __webpack_public_path__ + "static/media/139-venezuela.63e9f8e4.svg";